
import { useState } from 'react';

export const useHiddenSeries = () => {
  const [hiddenSeries, setHiddenSeries] = useState<string[]>([]);

  const toggleSeriesVisibility = (dataKey: string) => {
    setHiddenSeries(prevHidden => 
      prevHidden.includes(dataKey)
        ? prevHidden.filter(key => key !== dataKey)
        : [...prevHidden, dataKey]
    );
  };

  return {
    hiddenSeries,
    toggleSeriesVisibility
  };
};
